// Central mapping of blog post IDs to SEO-friendly slugs
// Used across Blog, BlogDetails, and all components that link to blog posts

export const blogSlugMap: Record<string, string> = {
  '1': 'fizikalna-terapija-za-bol-u-ledjima',
  '2': 'rehabilitacija-posle-operacije-kolena',
  '3': 'laserska-terapija-u-fizikalnoj-medicini',
  '4': 'ahilova-tetiva-rehabilitacija',
  '5': 'bol-u-ledjima-uzroci-vrste-oporavak',
  '6': 'teniski-lakat-simptomi-oporavak',
  '7': 'diskus-hernija-simptomi-rehabilitacija',
  '8': 'isijas-uzroci-simptomi-oporavak',
  '9': 'bol-u-vratu-uzroci-simptomi-prevencija',
  '10': 'skolioza-prepoznavanje-tretman',
  '11': 'kifoza-pogrbljeno-drzanje-prirodna-postura',
  '12': 'bol-u-kolenu-uzroci-dijagnoza-oporavak',
  '13': 'bol-u-ramenu-uzroci-oporavak',
  '14': 'sta-je-kiropraktika',
  '15': 'proces-fizikalne-terapije-donja-ledja',
  '16': 'fizikalna-terapija-teniskog-lakta',
  '17': 'kiropraktika-za-kancelarijske-radnike',
  '18': 'kiropraktika-glavobolje-i-vrtoglavice',
  '19': 'kiropraktika-nervni-blokovi',
  '20': 'fizikalna-terapija-rameni-pojas',
  '21': 'sta-je-fizikalna-terapija',
  '22': 'terapeutska-masaza-tehnike-prednosti',
  '23': 'rehabilitacija-sportista-fizikalna-terapija',
  '24': 'fizikalna-terapija-hronicni-bol',
  '25': 'masaza-bol-vrat-ramena',
  '26': 'postoperativna-rehabilitacija-faze-oporavka',
  '27': 'povrede-kolena-posle-skijanja',
  '28': 'bol-u-ledjima-posle-skijanja',
  '29': 'povrede-ramena-vrata-posle-skijanja',
  '30': 'prevencija-povreda-pre-skijanja',
  '31': 'zagrevanje-istezanje-pre-skijanja',
  '32': 'oporavak-posle-pada-na-skijanju',
  '33': 'skijaska-oprema-prevencija-povreda',
  '34': 'rehabilitacija-skijaskih-povreda',
  '35': 'prelom-kuka-pad-na-ledu',
  '36': 'povrede-zglobova-pad-na-ledu',
  '37': 'prevencija-pada-na-ledu',
  '38': 'povreda-kolena-pad-na-ledu',
  '39': 'oporavak-kolena-posle-pada-na-ledu',
  '40': 'prevencija-povreda-kolena-zima',
  '41': 'kiropraktika-glavobolja',
  '42': 'kiropraktika-donja-ledja',
  '43': 'kiropraktika-vrat',
  '44': 'kiropraktika-sportisti',
  '45': 'kiropraktika-stres',
  '46': 'kiropraktika-trudnice',
  '47': 'shockwave-terapija-indikacije',
  '48': 'shockwave-terapija-mehanizam-delovanja',
  '49': 'shockwave-terapija-prednosti',
  '50': 'smrznuto-rame-adhezivni-kapsulitis',
  '51': 'zatezanje-koze-shockwave-terapija',
  '52': 'diskus-hernija-vodic',
  '53': 'plantarni-fascitis-uzroci-tretman',
  '54': 'bol-u-kuku-uzroci-rehabilitacija',
  '55': 'tens-terapija-elektroterapija',
  '56': 'upala-ahilove-tetive-uzroci-rehabilitacija',
  '57': 'bol-u-ramenu-tokom-spavanja',
  '58': 'vezbe-za-jacanje-ledja',
  '59': 'skidanje-masti-shockwave-terapija',
  '60': 'ishrana-skidanje-masti-saveti',
  '61': 'vezbe-za-skidanje-masti',
  '62': 'celulit-uzroci-tretman',
  '63': 'oblikovanje-tela-shockwave',
  '64': 'zatezanje-koze-prirodno',
  '65': 'petni-trn-uzroci-tretman',
  '66': 'plantarni-fascitis-fizikalna-terapija',
  '67': 'rehabilitacija-posle-operacije-cukljeva',
  '68': 'prvi-dolazak-physiowrld',
  '69': 'sportska-masaza-prednosti-sportisti',
  '70': 'terapeutska-masaza-bol-ledja-vrat',
  '71': 'relaks-masaza-smanjenje-stresa',
  '72': 'fizikalna-terapija-posle-operacije-kuka',
  '73': 'ultrazvucna-terapija-kako-deluje',
  '74': 'elektroterapija-fizikalna-medicina',
  '75': 'kiropraktika-bol-kukovi',
  '76': 'kiropraktika-drzanje-tela',
  '77': 'kiropraktika-isijas-prirodni-tretman',
  '78': 'anatomija-kicme-vodic',
  '79': 'lordoza-hiperlordoza-korekcija',
  '80': 'kicmeni-diskovi-struktura-ostecenja',
  '81': 'sindrom-karpalnog-tunela-uzroci-tretman',
  '82': 'cervikalni-sindrom-simptomi-terapija',
  '83': 'osteoporoza-prevencija-fizikalna-terapija',
  '84': 'lumbalni-sindrom-lumbago-uzroci-lecenje',
  '85': 'artroza-kolena-gonartroza-simptomi-terapija',
  '86': 'impingement-sindrom-ramena-terapija',
  '87': 'fibromijalgija-simptomi-terapija',
  '88': 'epikondilitis-lakta-uzroci-lecenje',
  '89': 'radikulopatija-simptomi-terapija',
  '90': 'tendinitis-upala-tetiva-terapija',
  '91': 'miofascijalni-bolni-sindrom',
  '92': 'spondilolisteza-uzroci-terapija',
  '93': 'adhezivni-kapsulitis-smrznuto-rame',
  '94': 'lordoza-kicme-korekcija',
  '95': 'skolioza-deca-rano-otkrivanje',
  '96': 'torakalni-sindrom-bol-grudni-deo',
  '97': 'rehabilitacija-posle-preloma',
  '98': 'sindrom-prenaprezanja-overuse',
  '99': 'burzitis-upala-burze-terapija',
  '100': 'stenoza-kicmenog-kanala-terapija',
  '101': 'hronicni-umor-fizikalna-terapija',
  '102': 'periartritis-ramena-terapija',
  '103': 'sakroilijacna-disfunkcija-bol-karlica',
  '104': 'migrena-fizikalna-terapija',
  '105': 'plantarni-fascitis-shockwave-terapija',
  '106': 'cervikogena-glavobolja-terapija',
  '107': 'sindrom-piriformisa-bol-zadnjica',
  '108': 'kalkifikacija-ramena-terapija',
  '109': 'isijalgija-trudnoca-terapija',
  '110': 'sindrom-grudnog-otvora-terapija',
  '111': 'entezitis-upala-pripoja-tetiva',
  '112': 'degenerativna-bolest-diskusa',
  '113': 'sindrom-pretibijalnog-stresa-shin-splints',
  '114': 'kokcigodinija-bol-trticna-kost',
  '115': 'mortonov-neurom-bol-stopalo',
  '116': 'patelarna-tendinopatija-skakacko-koleno',
  '117': 'dupuytrenova-kontraktura-prsti-dlan',
  '118': 'de-kervenov-sindrom-bol-rucni-zglob',
  '119': 'trohantericki-burzitis-bol-kuk',
  '120': 'sindrom-tarzalnog-tunela-bol-stopalo',
  '121': 'tendinopatija-rotatorne-manzetne-bol-rame',
  '122': 'sakroileitis-upala-si-zgloba',
  '123': 'temporomandibularni-poremecaj-vilicni-zglob',
  '124': 'tendinopatija-bicepsa-bol-rame',
  '125': 'metatarzalgija-bol-prednji-deo-stopala',
  '126': 'sindrom-kubitalnog-tunela-ulnarni-nerv',
  '127': 'hallux-rigidus-ukoceni-palac-stopala',
  '128': 'bekerova-cista-kolena',
  '129': 'zasto-terapije-za-rame-ne-daju-rezultat',
  '130': 'zasto-vas-ledja-i-dalje-bole-posle-terapije',
  '131': 'sportske-povrede-koje-se-stalno-vracaju',
  '132': 'bol-u-vratu-i-glavobolje-skrivena-veza',
  '133': 'sindrom-prenaprezanja-desk-workeri',
  '134': 'bol-u-kuku-koji-se-siri-niz-nogu',
  '135': 'zasto-istezanje-ne-pomaze-kod-hronicnog-bola',
  '136': 'bol-u-zglobu-sake-uzroci-terapija',
  '137': 'rehabilitacija-posle-mozdanog-udara',
  '138': 'vestibularna-rehabilitacija-vrtoglavica',
  '140': 'rehabilitacija-posle-operacije-ramena',
  '141': 'limfna-drenaza-posle-liposukcije',
  '142': 'otecene-noge-uzroci-limfna-drenaza-presoterapija',
  '143': 'presoterapija-posle-treninga-trcanja',
  '144': 'manuelna-vs-aparaturna-limfna-drenaza',
  '145': 'limfna-drenaza-trudnoca-i-porodjaj',
  '146': 'otecene-noge-dugi-let-avionom',
  '147': 'limfedem-uzroci-faze-tretman',
  '148': 'presoterapija-kancelarijski-radnici-sedenje',
  '149': 'skidanje-masti-stomak-shockwave',
  '150': 'shockwave-vs-liposukcija',
  '151': 'skidanje-masti-posle-porodjaja',
  '152': 'skidanje-masti-butine-galife',
  '153': 'awt-terapija-akusticni-talasi-hronicni-bol',
  '154': 'cena-awt-tretmana-beograd',
  '155': 'awt-vs-ortopedski-ulosci-vs-kortikosteroidi-petni-trn',
  '156': 'kontraindikacije-awt-terapije',
  '157': 'cena-manuelne-limfne-drenaze-beograd',
  '158': 'manuelna-limfna-drenaza-posle-operacije',
  '159': 'kontraindikacije-manuelne-limfne-drenaze',
  '160': 'limfna-drenaza-lica',
  '161': 'limfna-drenaza-za-sportiste',
  '162': 'priprema-za-manuelnu-limfnu-drenazu',
  '163': 'da-li-limfna-drenaza-pomaze-za-mrsavljenje',
  '164': 'limfna-drenaza-ruke-posle-mastektomije',
  '165': 'koliko-cesto-raditi-limfnu-drenazu',
  '166': 'vezbe-za-petni-trn',
  '167': 'petni-trn-oporavak-koliko-traje',
  '168': 'tretman-celulita-stadijum-3-4',
  '169': 'tretman-celulita-butine-zadnjica',
  '170': 'uklanjanje-celulita-bez-operacije',
  '171': 'limfna-drenaza-nogu-otoci',
  '172': 'zadrzavanje-vode-u-telu-limfna-drenaza',
  '173': 'limfna-drenaza-efekti-posle-prve-seanse',
  '174': 'kiropraktika-cena-koliko-tretmana',
  '175': 'kiropraktika-bezbednost-kontraindikacije',
  '176': 'kiropraktika-ili-fizikalna-terapija',
  '177': 'tecar-terapija-cena-indikacije',
  '178': 'rehabilitacija-posle-acl-operacije-faze',
  '179': 'korektivne-vezbe-za-decu-kada-poceti',
  '180': 'shockwave-terapija-teniski-lakat',
  '181': 'presoterapija-cena-koliko-traje',
  '182': 'anticelulit-tretman-koliko-tretmana',
  '183': 'rehabilitacija-posle-preloma-rucnog-zgloba',
  '184': 'prelom-skocnog-zgloba-oporavak',
  '185': 'prelom-kuka-rehabilitacija-stariji',
  '186': 'masaza-terapeutska-sportska-relax',
  '187': 'koliko-cesto-ici-na-masazu',
  '188': 'masaza-za-bol-u-ledjima-i-vratu',
  '189': 'skidanje-masti-awt-limfna-drenaza',
  '190': 'povrede-kolena-na-skijanju-acl-meniskus',
  '191': 'povrede-kuka-na-skijanju',
  '192': 'skijaski-palac-i-povrede-rucnog-zgloba',
  '193': 'bol-u-vratu-i-vratnom-delu-kicme',
  '194': 'isijas-simptomi-lecenje-vezbe',
  '195': 'bol-u-donjem-delu-ledja',
  '196': 'priprema-za-skijasku-sezonu-vezbe',
  '197': 'bol-u-zglobovima-hladno-vreme',
  '198': 'bol-u-stopalu-i-peti-zimi',
  '199': 'spontana-osteonekroza-kolena-sonk',
  '200': 'limfna-drenaza-i-celulit',
  '201': 'wolffov-zakon-kosti-opterecenje-rehabilitacija',
  '202': 'osteopenija-sta-znaci-dexa-nalaz-vezbe',
  '203': 'meniskus-kolena-simptomi-lecenje-rehabilitacija',
  '204': 'ravna-stopala-deca-odrasli-vezbe',
  '205': 'vezbe-za-gonartrozu-kolena-program',
  '206': 'uganuce-skocnog-zgloba-oporavak-vezbe',
  '207': 'ukocen-vrat-tortikolis-sta-pomaze',
  '208': 'bol-izmedju-lopatica-uzroci-lecenje',
  '209': 'bol-ispred-kolena-patelofemoralni-bol',
  '210': 'istegnuce-zadnje-loze-oporavak-vezbe',
  '211': 'bol-u-preponama-kod-sportista',
  '212': 'hernija-vrata-c5-c6',
  '213': 'hernija-l5-s1',
};

// Legacy slugs → id (kept for 301 redirects from indexed URLs)
export const legacyBlogSlugMap: Record<string, string> = {
  'bejkerova-cista-kolena-poplitealna-cista': '128',
};

// Reverse map: slug → id
const slugToIdMap: Record<string, string> = {
  ...legacyBlogSlugMap,
  ...Object.fromEntries(
    Object.entries(blogSlugMap).map(([id, slug]) => [slug, id])
  ),
};

/** Get slug from blog post ID */
export const getBlogSlug = (id: string | number): string => {
  return blogSlugMap[id.toString()] || id.toString();
};

/** Get blog post ID from slug (returns the slug itself if it's already a numeric ID) */
export const getBlogIdFromSlug = (slugOrId: string): string => {
  // If it's a numeric ID, return as-is
  if (/^\d+$/.test(slugOrId)) return slugOrId;
  // Look up the slug
  return slugToIdMap[slugOrId] || slugOrId;
};

/** Get the blog URL path for a given post ID */
export const getBlogUrl = (id: string | number): string => {
  return `/blog/${getBlogSlug(id)}`;
};
